import React from "react";
import { Box, Input, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import search from "../icons/magnifying-glass.svg";
import tick from "../icons/check-circle-filled.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import SimpleText from "./SimpleText";

const RightPlan = ({ content }) => {
  const theme = useTheme();
  const isPad = useMediaQuery("(max-width:900px)");

  const Button = styled(MuiButton)((props) => ({
    borderRadius: 50,
    background: theme.palette.secondary.main,
    padding: "0 5% 0 5%",
    color: theme.palette.white.main,

    width: "10%",
    height: "100%",
  }));
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: {
          xs: "7% 11% 2% 11%",
          sm: "7% 11% 2% 11%",
          md: "7% 11% 2% 11%",
          lg: "0% 0 2% 0",
        },
        flexDirection: "column",
      }}
    >
      <Box
        mt="2%"
        sx={{
          whiteSpace: { xs: "wrap", sm: "wrap", md: "wrap", lg: "nowrap" },
          border: `2px ${theme.palette.secondary.light} solid`,
          borderRadius: { xs: "5vw", sm: "5vw", md: "5vw", lg: "20px" },
          position: "relative",
          boxSizing: "border-box",
          padding: {
            xs: "5% 8% 5% 8%",
            sm: "5% 8% 5% 8%",
            md: "5% 10% 5% 10%",
            lg: "20px 166px",
          },
          display: "flex",
          // alignItems: "center",
          width: {
            xs: "100%",
            sm: "100%",
            md: "100%",
            lg: "94%",
          },
          flexDirection: "column",
        }}
      >
        <SimpleText
          style={{
            fontSize: { xs: "16px", md: "3.3vw", lg: "20px" },
            marginBottom: { xs: "5%", sm: "5%", md: "5%", lg: 0 },
          }}
          text={content?.details?.feature[0]?.label}
        />
        <Box
          width="30%"
          sx={{
            display: "flex",
            // alignItems: "space-between",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" },
            width: "100%",
          }}
          ml={{ xs: "0", sm: "0", md: "0%", lg: "0" }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",

              flexDirection: "row",
              width: { xs: "25%", sm: "25%", md: "20%", lg: "11%" },
              marginTop: "2%",
              whiteSpace: "nowrap",
            }}
          >
            {isPad ? (
              <img style={{ marginRight: "10%" }} width="30%" src={tick} />
            ) : (
              <img style={{ marginRight: "10%" }} width="100%" src={tick} />
            )}
            <Typography
              fontSize={{ xs: "16px", md: "2.8vw", lg: "20px" }}
              mb="5%"
            >
              {content?.details?.feature[0]?.option1}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",

              flexDirection: "row",
              width: { xs: "25%", sm: "25%", md: "20%", lg: "11%" },
              marginTop: "2%",
              whiteSpace: "nowrap",
            }}
          >
            {isPad ? (
              <img style={{ marginRight: "10%" }} width="30%" src={tick} />
            ) : (
              <img style={{ marginRight: "10%" }} width="100%" src={tick} />
            )}
            <Typography
              fontSize={{ xs: "16px", md: "2.8vw", lg: "20px" }}
              mb="5%"
            >
              {content?.details?.feature[0]?.option2}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",

              flexDirection: "row",
              width: { xs: "25%", sm: "25%", md: "20%", lg: "11%" },
              marginTop: "2%",
              whiteSpace: "nowrap",
            }}
          >
            {isPad ? (
              <img style={{ marginRight: "10%" }} width="30%" src={tick} />
            ) : (
              <img style={{ marginRight: "10%" }} width="100%" src={tick} />
            )}
            <Typography
              fontSize={{ xs: "16px", md: "2.8vw", lg: "20px" }}
              mb="5%"
            >
              {content?.details?.feature[0]?.option3}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default RightPlan;
